var map = {
	"./1.jpg": 8152,
	"./10.jpg": 8834,
	"./11.jpg": 6767,
	"./2.jpg": 5431,
	"./3.jpg": 7914,
	"./4.jpg": 4377,
	"./5.jpg": 9116,
	"./6.jpg": 6091,
	"./7.jpg": 4782,
	"./8.jpg": 2525,
	"./9.jpg": 6960
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6490;